import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderBiblicalAnswers from "../../../../src/content/biblicalanswers/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderBiblicalAnswers,
  React
};